<div class="maintenance-table-container">
  <div class="table-container" [ngClass]="TABLE_CONFIG['TABLE_CLASS']">
    <div class="bulk-upload-header" *ngIf="BulkUpload">
      <h6 class="headerTable valid-count" *ngIf="!isInvalidTable">Valid count {{ dataSource?.data?.length }}</h6>

      <h6 class="headerTable invalid-count" *ngIf="isInvalidTable">Invalid count {{ dataSource?.data?.length }}</h6>

      <div class="error-toggle-container" *ngIf="isInvalidTable">
        <span class="switch-toggle-label me-1 toggle-ytd-label">Errors Fields</span>
        <mat-slide-toggle
          [color]="'#013b71'"
          class="toggle-margin app-toggle"
          [(ngModel)]="checked"
          (change)="onToggleChange()"
        >
        </mat-slide-toggle>
        <span class="switch-toggle-label ms-1 toggle-ytd-label">Show All Fields</span>
      </div>
    </div>
    <table
      mat-table
      [dataSource]="dataSource"
      (matSortChange)="sortData($event)"
      matSort
      class="mat-elevation-z8"
      [ngClass]="TABLE_CONFIG.isOptum ? 'optumTblCss' : ''"
      multiTemplateDataRows
      *ngIf="!BulkUpload || (BulkUpload && dataSource?.data?.length > 0)"
    >
      <!-- Checkbox Column -->

      <ng-container [matColumnDef]="col.key" *ngFor="let col of COLUMNS; let i = index">
        <ng-container>
          <ng-container *ngIf="col.matColumnDef == 'select'">
            <th mat-header-cell *matHeaderCellDef [style.width]="col.width">
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" [style.width]="col.width">
              <ng-container *ngIf="!row.isNew && !row.hideCheckbox">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="cheskboxChanged($event, row)"
                  [checked]="selection.isSelected(row)"
                >
                </mat-checkbox>
              </ng-container>
            </td>
          </ng-container>
          <ng-container *ngIf="col.sortable">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [style.width]="col.width"
              [style.textAlign]="col.align"
              [style.padding]="col.padding"
              [ngClass]="col.class"
              [style.paddingLeft]="col?.uomPaddingLeft"
            >
              {{ col['label'] }}
              <span *ngIf="col.key == 'MBO_Segment' && col.filter">
                <span
                  *ngIf="!SegmentFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="SegmentFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'MBO_Segment_ID' && col.filter">
                <span
                  *ngIf="!decomIdFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="decomIdFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Leader_Msid' && col.filter">
                <span
                  *ngIf="!decomFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="decomFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'SRVDESC' && col.filter">
                <span
                  *ngIf="!serviceFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="serviceFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Service' && col.filter">
                <span
                  *ngIf="!serviceKeyFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="serviceKeyFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Category' && col.filter">
                <span
                  *ngIf="!categoryFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="categoryFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Public_Private_Cloud' && col.filter">
                <span
                  *ngIf="!Public_Private_CloudFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="Public_Private_CloudFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Complex_Services' && col.filter">
                <span
                  *ngIf="!Complex_ServicesFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="Complex_ServicesFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'UI_Comments' && col.filter">
                <span
                  *ngIf="!UI_CommentsFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="UI_CommentsFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Edit_TOH' && col.filter">
                <span
                  *ngIf="!Edit_TOHFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="Edit_TOHFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'SRV_Disable' && col.filter">
                <span
                  *ngIf="!SRV_DisableFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="SRV_DisableFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'App_NonApp' && col.filter">
                <span
                  *ngIf="!App_NonAppFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="App_NonAppFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Feature' && col.filter">
                <span
                  *ngIf="!FeatureFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="FeatureFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Role' && col.filter">
                <span
                  *ngIf="!RoleAccessFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="RoleAccessFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Secure_Group' && col.filter">
                <span
                  *ngIf="!SecureGroupFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="SecureGroupFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
            </th>
          </ng-container>
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="col.width"
            [style.textAlign]="col.align"
            [style.padding]="col.padding"
          >
            <div *ngIf="col['label'] != 'Action'; else orgAction">
              <span *ngIf="BulkUpload && i === 0">
                <button mat-icon-button (click)="toggleHead(); $event.stopPropagation()" class="expand-all-button">
                  <mat-icon class="expansion-icon">
                    {{ allRowsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                  </mat-icon>
                </button>
              </span>
              {{ col['label'] }}
              <span *ngIf="(col.key == 'MasterSegment' || col.key == 'Master_Segment') && col.filter">
                <span
                  *ngIf="!SegmentFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="SegmentFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'DecomLobID' && col.filter">
                <span
                  *ngIf="!decomIdFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="decomIdFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="(col.key == 'CIOLOB' || col.key == 'lob') && col.filter">
                <span
                  *ngIf="!LobFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="LobFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'User_Role' && col.filter">
                <span
                  *ngIf="!userRoleFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="userRoleFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Sub_LOB' && col.filter">
                <span
                  *ngIf="!sblobFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="sblobFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'displayName' && col.filter">
                <span
                  *ngIf="!isNameFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="isNameFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'MULTI_SRV' && col.filter">
                <span
                  *ngIf="!multiSRVFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="multiSRVFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'year' && col.filter">
                <span
                  *ngIf="!yearFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="yearFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>
              <span *ngIf="col.key == 'Users' && col.filter">
                <span
                  *ngIf="!usersFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                <span
                  *ngIf="usersFilterApplied"
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
              </span>

              <span
                *ngIf="col.filter && BulkUpload"
                [matMenuTriggerFor]="menuBulk"
                #trigger="matMenuTrigger"
                (click)="$event.stopPropagation()"
              >
                <img
                  class="stkh-table-filter-img"
                  [src]="
                    col.searchValue.length > 0
                      ? '../../../../assets/images/table_filter_applied.png'
                      : '../../../../assets/images/table_filter.png'
                  "
                />
              </span>
              <mat-menu #menuBulk>
                <div
                  class="menu-filter-popup"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                  *ngIf="dataSchema"
                >
                  <ng-container [ngSwitch]="dataSchema[col.key]">
                    <ng-container *ngSwitchCase="'select'">
                      <input
                        matInput
                        type="text"
                        class="searchoption form-control filter-search-bar"
                        (keydown)="$event.stopPropagation()"
                        [(ngModel)]="col.search"
                        placeholder="Search"
                      />
                      <mat-selection-list
                        [disableRipple]="true"
                        class="filter-list-container"
                        [(ngModel)]="col.searchValue"
                      >
                        <mat-list-option
                          checkboxPosition="before"
                          *ngFor="let option of getFiltersList(col, 'filter') | filter: col.search"
                          [value]="option.key"
                        >
                          {{ option.value }}
                        </mat-list-option>
                      </mat-selection-list>
                      <span
                        style="cursor:pointer; float: right;padding-right: 21px;"
                        class="localApplyButton"
                        (click)="applyBulkLocalFilter(col)"
                        >Apply</span>
                      <span
                        style="cursor:pointer; float: right;padding-right: 21px;"
                        class="localApplyButton"
                        (click)="clearBulkLocalFilter(col)"
                        >Clear</span>
                    </ng-container>
                  </ng-container>
                </div>
              </mat-menu>

              <mat-menu #contextMenu="matMenu">
                <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                  <input
                    matInput
                    type="text"
                    class="searchoption"
                    (keydown)="$event.stopPropagation()"
                    class="form-control filter-search-bar"
                    [(ngModel)]="searchTxt"
                    placeholder="Search"
                  />
                  <mat-selection-list
                    class="filter-list-container"
                    (selectionChange)="selectionChange($event, col)"
                    [disableRipple]="true"
                    [(ngModel)]="filValue"
                  >
                    <mat-list-option
                      checkboxPosition="before"
                      *ngFor="let row of filterLists | search: searchTxt"
                      [value]="row"
                    >
                      {{ row }}
                    </mat-list-option>
                  </mat-selection-list>
                  <span
                    style="cursor:pointer; float: right;padding-right: 70px;"
                    class="small localApplyButton"
                    (click)="applyLocalFilter()"
                    >Apply</span>
                  <span
                    style="cursor:pointer; float: right;padding-right: 22px;"
                    class="small localApplyButton"
                    (click)="clearLocalFilter(col)"
                    >Clear</span>
                </div>
              </mat-menu>

              <span
                class="pull-right pe-3"
                *ngIf="
                  col.key == 'Actions' &&
                  (SegmentFilterApplied ||
                    LobFilterApplied ||
                    sblobFilterApplied ||
                    isNameFilterApplied ||
                    userRoleFilterApplied ||
                    multiSRVFilterApplied ||
                    yearFilterApplied ||
                    serviceFilterApplied ||
                    decomFilterApplied ||
                    decomIdFilterApplied ||
                    categoryFilterApplied ||
                    serviceKeyFilterApplied ||
                    Public_Private_CloudFilterApplied ||
                    Edit_TOHFilterApplied ||
                    SRV_DisableFilterApplied ||
                    Complex_ServicesFilterApplied ||
                    UI_CommentsFilterApplied ||
                    App_NonAppFilterApplied ||
                    usersFilterApplied ||
                    FeatureFilterApplied ||
                    RoleAccessFilterApplied ||
                    SecureGroupFilterApplied)
                "
                (click)="clearallFilter()"
              >
                <i
                  title="Reset Filters"
                  class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                ></i>
              </span>
            </div>
            <ng-template #orgAction>
              <div *ngIf="TABLE_CONFIG.edit">{{ col['label'] }}</div>
            </ng-template>
          </th>
          <mat-menu #contextMenu="matMenu">
            <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <input
                matInput
                type="text"
                class="searchoption"
                (keydown)="$event.stopPropagation()"
                class="form-control filter-search-bar"
                [(ngModel)]="searchTxt"
                placeholder="Search"
              />
              <mat-selection-list
                class="filter-list-container"
                (selectionChange)="selectionChange($event, col)"
                [disableRipple]="true"
                [(ngModel)]="filValue"
              >
                <mat-list-option
                  checkboxPosition="before"
                  *ngFor="let row of filterLists | search: searchTxt"
                  [value]="row"
                >
                  {{ row }}
                </mat-list-option>
              </mat-selection-list>
              <span
                style="cursor:pointer; float: right;padding-right: 70px;"
                class="small localApplyButton"
                (click)="applyLocalFilter()"
                >Apply</span>
              <span
                style="cursor:pointer; float: right;padding-right: 22px;"
                class="small localApplyButton"
                (click)="clearLocalFilter(col)"
                >Clear</span>
            </div>
          </mat-menu>
        </ng-container>
        <ng-container *ngIf="dataSource?.data.length > 0">
          <td
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            [style.textAlign]="col.align"
            [style.width]="col.width"
            [style.padding]="col.padding"
          >
            <ng-container *ngIf="element.isEdit; else eleNotEdit">
              <div class="btn-edit align-items-center" *ngIf="col.key === 'isEdit'; else dataField">
                <span
                  class="save-screen-icon"
                  title="save"
                  (click)="saveRecord(element)"
                  [class.disabled]="getDisableFlag(element)"
                >
                  <mat-icon class="icon-crud">save</mat-icon>
                </span>
                &nbsp;
                <span class="cancel-screen-icon" title="cancel" (click)="deleteRecord(element, i)">
                  <mat-icon class="icon-crud">cancel</mat-icon>
                </span>
                &nbsp;
                <span
                  class="cancel-screen-icon"
                  *ngIf="TABLE_CONFIG && TABLE_CONFIG?.deleteFeature && !TABLE_CONFIG.isOptum"
                  title="delete"
                  (click)="removeRecord(element)"
                  [class.disabled]="getDisableDelete(element)"
                >
                  <mat-icon class="icon-crud">delete</mat-icon>
                </span>
              </div>
              <ng-template #dataField>
                <ng-container *ngIf="col.edit || element.isNew; else defaultViewColumn">
                  <ng-container [ngSwitch]="dataSchema[col.key]">
                    <ng-container *ngSwitchDefault>
                      <mat-form-field
                        *ngIf="col.key === 'org_name' || col.key === 'optum_tech_labour'"
                        [ngClass]="col.key"
                        class="inline-form-edit p-0"
                        floatLabel="never"
                      >
                        <div *ngIf="col.key === 'optum_tech_labour'" style="margin-bottom: 1.21%;">$</div>
                        <input
                          [attr.type]="col.key === 'optum_tech_labour' ? 'number' : null"
                          [ngClass]="{ optumWidth: col.key === 'optum_tech_labour' }"
                          placeholder="{{
                            col.key === 'org_name'
                              ? 'Enter Organization'
                              : col.key === 'optum_tech_labour'
                              ? 'Enter Optum Tech Labour'
                              : col.key
                          }}"
                          [type]="dataSchema[col.key]"
                          matInput
                          [(ngModel)]="element[col.key]"
                          (ngModelChange)="changedOptumEvent($event, element)"
                        />
                      </mat-form-field>
                      <span *ngIf="col.key === 'org_id' || (col.key === 'Decom_Target_Year' && !element.isNew)">
                        {{ element[col.key] }}
                      </span>
                      <div class="lob-chip-field lob-border">
                        <div class="lob-chip-field lob-border" *ngIf="col.key === 'Decom_Target_Year' && element.isNew">
                          <ng-container>
                            <mat-form-field
                              appearance="fill"
                              class="inline-form-edit sublob-edit-architects"
                              floatLabel="never"
                            >
                              <p class="leader-input-align">
                                <input
                                  matInput
                                  class="leader-input"
                                  [matAutocomplete]="auto"
                                  [(ngModel)]="leaderName"
                                  (keyup)="keyUpSearch($event)"
                                  placeholder="Search by Name/Mail"
                                />
                              </p>
                            </mat-form-field>
                            <mat-autocomplete
                              showPanel="true"
                              class="lob-options-list dropdown-width"
                              #auto="matAutocomplete"
                            >
                              <mat-option
                                *ngFor="let user of users"
                                (onSelectionChange)="selectionleaderChanged(user)"
                                [disabled]="existingLeaderIds.includes(user.msid) == true"
                                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})"
                                [value]="user.displayName"
                              >
                                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                              </mat-option>
                            </mat-autocomplete>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #defaultViewColumn>
                  {{ element[col.key] }}
                </ng-template>
              </ng-template>
            </ng-container>
            <ng-template [ngSwitch]="col.key" #eleNotEdit>
              <div class="btn-edit" *ngSwitchCase="'isEdit'">
                <div *ngIf="TABLE_CONFIG.edit" class="d-flex align-items-center edit-icon">
                  <span class="edit-screen-icon" (click)="enableEditView(element, i)">
                    <mat-icon class="icon-crud">edit</mat-icon>
                  </span>
                  <span *ngIf="TABLE_CONFIG.isOptum">
                    <mat-icon
                      (click)="cancelRecord(element)"
                      class="mat-icon notranslate material-icons edit-screen-icon"
                      style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                      aria-hidden="true"
                      data-mat-icon-type="font"
                    >
                      delete
                    </mat-icon>
                  </span>
                </div>
              </div>
              <span *ngSwitchCase="'Users'">
                <div class="scroll-elements">
                  <table>
                    <tbody>
                      <tr *ngFor="let option of element[col.key]">
                        <td>
                          {{ option?.displayName }}<span *ngIf="option?.mail"> {{ option?.mail }} ></span><span *ngIf="option?.msid"> ({{ option?.msid }})</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </span>
              <span *ngSwitchCase="'SRVDESC'">
                <ng-container *ngIf="col?.action === 'download'; else srvDescDefault">                


                  <span
                    *ngIf="(element[col.key] || '').toString().toLowerCase() === 'completed'"
                    class="status-action-icons"
                  >
                    <span class="status-tooltip-wrapper">
                      <span class="download-icon-wrapper text-success">
                        <mat-icon
                          class="status-mat-icon"
                          [class.download-disabled]="isDownloadInProgress(element)"
                          (click)="!isDownloadInProgress(element) && onDownloadClick(element); $event.stopPropagation()"
                          >download</mat-icon>
                        <mat-progress-spinner
                          *ngIf="isDownloadInProgress(element)"
                          class="download-inline-spinner"
                          [diameter]="24"
                          mode="indeterminate"
                        ></mat-progress-spinner>
                      </span>
                      <div class="status-tooltip-card" (click)="$event.stopPropagation()">
                        <div class="status-tooltip-arrow"></div>
                        <div
                          class="status-tooltip-content"
                          [innerHTML]="getStatusTooltipHtml('completed')"
                          (click)="onStatusTooltipClick($event)"
                        ></div>
                      </div>
                    </span>
                    <span
                      *ngIf="canShowShareIcon(element)"
                      class="save-screen-icon"
                      title="share"
                      (click)="onShareClick(element); $event.stopPropagation()"
                    >
                      <mat-icon class="icon-crud excelandinfo-Icon-font">share</mat-icon>
                    </span>
                  </span>
                  <span
                    *ngIf="(element[col.key] || '').toString().toLowerCase() === 'failed'"
                    class="status-tooltip-wrapper status-center"
                  >
                    <mat-icon class="status-mat-icon text-danger">cancel</mat-icon>
                    <div class="status-tooltip-card" (click)="$event.stopPropagation()">
                      <div class="status-tooltip-arrow"></div>
                      <div
                        class="status-tooltip-content"
                        [innerHTML]="getStatusTooltipHtml('failed')"
                        (click)="onStatusTooltipClick($event)"
                      ></div>
                    </div>
                  </span>                 

                  <span
                    *ngIf="(element[col.key] || '').toString().toLowerCase() === 'in progress'"
                    class="status-tooltip-wrapper status-center"
                  >
                    <mat-icon class="status-mat-icon text-warning">schedule</mat-icon>
                    <div class="status-tooltip-card" (click)="$event.stopPropagation()">
                      <div class="status-tooltip-arrow"></div>
                      <div
                        class="status-tooltip-content"
                        [innerHTML]="getStatusTooltipHtml('in progress')"
                        (click)="onStatusTooltipClick($event)"
                      ></div>
                    </div>
                  </span>
                </ng-container>
                <ng-template #srvDescDefault>
                  <span class="service-block">
                    <span
                      class="int-label-txt"
                      matTooltipPosition="above"
                      matTooltip="Billed Under International Rate"
                      *ngIf="col?.showUOMrateData"
                      [ngClass]="{ 'visibility-hide': element.I_Flag != 'Yes' }"
                      >INT</span>
                    <span class="service-name">{{ element[col.key] }}</span>
                  </span>
                </ng-template>
              </span>
              <span *ngSwitchCase="'Actions'">
                <div class="action-buttons">
                  <span
  [matTooltip]="element.addDisabledTooltip"
  matTooltipPosition="above"
>
                  <button
                    mat-raised-button
                    *ngIf="TABLE_CONFIG?.showAddButtonRoles && element.popupDetails"
                    class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
                    style="font-size: 0.75rem; padding: 2px 10px; min-height: unset;"
                    [disabled]="isAddDisabledFn(element)"
                    [matTooltip]="element.addDisabledTooltip"
                    (click)="addEvent.emit(element)"
                  >
                    Add
                  </button>
                  </span>
                  <button
                    mat-icon-button
                    *ngIf="TABLE_CONFIG.edit"
                    class="align-edit"
                    (click)="loadEditLob(element)"
                    title="Click to Edit LOB"
                  >
                    <mat-icon
                      class="actionItems excelandinfo-Icon-font"
                      style="font-size: 1.1rem !important; cursor: pointer; color: #013B71;"
                    >
                      create
                    </mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    *ngIf="TABLE_CONFIG.commonEdit"
                    class="align-edit"
                    (click)="onEditClick(element)"
                    [title]="TABLE_CONFIG.commonEditLabel"
                  >
                    <mat-icon
                      class="actionItems excelandinfo-Icon-font"
                      style="font-size: 1.1rem !important; cursor: pointer; color: #013B71;"
                    >
                      create
                    </mat-icon>
                  </button>
                  &nbsp;
                  <ng-container class="action-buttons" *ngIf="!element.expand && TABLE_CONFIG?.expandable">
                    <ng-container *ngIf="selectedOption === 'decom_lob' && TABLE_CONFIG.DecomLobEditAccess">
                      <button mat-icon-button (click)="showAddEditPopup('parent', element)">
                        <mat-icon class="icon-crud editPencil">edit</mat-icon>
                      </button>
                    </ng-container>
                    <button
                      *ngIf="!element.expand && TABLE_CONFIG?.expandable && !isExpandIconAtStart && (!element.details || element.details.length > 0)"
                      mat-icon-button
                      (click)="expandDetailRow(element, true)"
                    >
                      <mat-icon class="actionItems-Expand addcircle material-icons mat-icon-no-color">
                        add_circle_outline</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      element.expand &&
                      TABLE_CONFIG?.expandable &&
                      selectedOption === 'decom_lob' &&
                      TABLE_CONFIG.DecomLobEditAccess
                    "
                  >
                    <button mat-icon-button (click)="showAddEditPopup('parent', element)">
                      <mat-icon class="icon-crud editPencil">edit</mat-icon>
                    </button>
                  </ng-container>
                  <button
                    mat-icon-button
                    *ngIf="element.expand && TABLE_CONFIG?.expandable && !isExpandIconAtStart && (!element.details || element.details.length > 0)"
                    (click)="collapseDetailRow(element)"
                  >
                    <mat-icon class="actionItems-Expand addcircle material-icons mat-icon-no-color">
                      remove_circle_outline</mat-icon>
                  </button>
                  <div *ngIf="TABLE_CONFIG.ruleInfo" (click)="shwRuleDtl(element)">
                    <mat-icon class="infoIcon">info</mat-icon>
                  </div>
                </div>
              </span>
              <span *ngSwitchCase="'Expand_Icon'">
                <div class="action-buttons">
                  <button
                    *ngIf="!element.expand && TABLE_CONFIG?.expandable && isExpandIconAtStart"
                    mat-icon-button
                    (click)="expandDetailRow(element, true)"
                  >
                    <mat-icon class="table-arrow-icon addcircle material-icons mat-icon-no-color">
                      keyboard_arrow_right</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    *ngIf="element.expand && TABLE_CONFIG?.expandable && isExpandIconAtStart"
                    (click)="collapseDetailRow(element)"
                  >
                    <mat-icon class="table-arrow-icon addcircle material-icons mat-icon-no-color">
                      keyboard_arrow_down</mat-icon>
                  </button>
                </div>
              </span>
              <span *ngSwitchDefault>
                <ng-container *ngIf="col.link; else defaultCon">
                  <a [href]="getNavigationLink(col, element)" target="blank">
                    {{ element[col.key] }}
                  </a>
                </ng-container>
                <ng-template #defaultCon>
                  <ng-container
                    *ngIf="col.key == 'optum_tech_labour' || col.key == 'Service_Owner_Details'; else secondCon"
                  >
                    <span *ngIf="col.key == 'optum_tech_labour'">{{ element[col.key] | currency }}</span>
                    <span *ngIf="col.key == 'Service_Owner_Details'"
                      >{{ element['Service_Owner_Name'] }}
                      <span *ngIf="element['Service_Owner_msid']">({{ element['Service_Owner_msid'] }})</span></span>
                  </ng-container>
                  <ng-template #secondCon>
                    <ng-container *ngIf="col.currency == true && element[col.key]; else leadEA">
                      $ {{ element[col.key] | number }}
                    </ng-container>
                    <ng-template #leadEA>
                      <div [style.textAlign]="col.align" *ngIf="col.key == 'leadEA'; else normalCon">
                        <span *ngIf="element[col.key] === 'Yes'">
                          <img
                            href=""
                            (click)="updateStatus(element)"
                            class="image-icon"
                            style="width: 20px;cursor: pointer;"
                            src="assets/images/Primary_Yes.svg"
                          />
                        </span>
                        <span *ngIf="element[col.key] === 'No'">
                          <img
                            href=""
                            (click)="updateStatus(element)"
                            class="image-icon"
                            style="width: 20px;cursor: pointer;"
                            src="assets/images/Primary_No.svg"
                          />
                        </span>
                      </div>
                    </ng-template>
                    <ng-template #normalCon>
                      <!-- class="message-row" class="arrow-container" class="message-text"-->
                      <div [ngClass]="{ 'message-row': BulkUpload }">
                        <div [ngClass]="{ 'arrow-container': BulkUpload }">
                          <span *ngIf="!(col?.type == 'date' || col?.type == 'numberFormat') && element[col.key]">
                            <span
                              *ngIf="
                                BulkUpload &&
                                ((col.key == 'Message' && isInvalidTable) ||
                                  (col.key == 'Update Type' && !isInvalidTable))
                              "
                            >
                              <button
                                mat-icon-button
                                (click)="toggleRow(element); $event.stopPropagation()"
                                class="expand-all-button"
                              >
                                <mat-icon class="expansion-icon">
                                  {{ isRowExpanded(element) ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                                </mat-icon>
                              </button>
                            </span>
                          </span>
                        </div>
                        <div [ngClass]="{ 'message-text': BulkUpload }">
                          <ng-container *ngIf="!(col?.type == 'date' || col?.type == 'numberFormat')">
                            {{ element[col.key] | commaSeparatedLines }}
                          </ng-container>
                        </div>

                        <span *ngIf="col?.type == 'date' && element[col.key]">
                          {{
                            col?.dateFormat
                              ? (element[col.key] | date: col?.dateFormat : col?.timeZone)
                              : (element[col.key] | date: 'dd/MM/yyyy' : col?.timeZone)
                          }}
                          <ng-container *ngIf="col?.timeZoneLabel"> {{ col?.timeZoneLabel }}</ng-container>
                        </span>
                        <span *ngIf="col?.type == 'numberFormat' && element[col.key]">
                          {{
                            col?.numberFormat
                              ? (element[col.key] | digitFormatter: col?.numberFormat)
                              : (element[col.key] | digitFormatter: '1')
                          }}
                        </span>
                      </div>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </span>
            </ng-template>
          </td>
        </ng-container>
      </ng-container>

      <div [hidden]="!TABLE_CONFIG.expandable">
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            [attr.colspan]="displayedColumns.length"
            style="background-color: #FFFFFF !important;"
          >
            <div
              class="app-padu-element-detail"
              *ngIf="element.expand"
              [hidden]="!element.childDataSource?.data"
              [@detailExpand]="element.expand ? 'expanded' : 'collapsed'"
            >
              <div class="inner-table mat-elevation-z8 table-container-inside">
                <table
                  #innerTables
                  mat-table
                  [dataSource]="element.childDataSource"
                  matSort
                  class="mat-elevation-z8 child-table-class"
                  style="border-left: 0.03vw solid #013B71"
                >
                  <ng-container
                    matColumnDef="{{ innerColumn.key }}"
                    *ngFor="let innerColumn of (element.customColumns || expanded_columns); let colIndex = index"
                  >
                    <ng-container>
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        class="table-light-background"
                        [style.width]="innerColumn.width"
                      >
                        <span>
                          <ng-container *ngIf="innerColumn.key === 'select'; else innerRegularHeader">
                            
                            <mat-checkbox
                              *ngIf="!TABLE_CONFIG?.hideChildHeaderCheckbox"
                              (change)="$event ? masterToggleChild(element.childDataSource) : null"
                              [checked]="isAllChildSelected(element.childDataSource)"
                              [indeterminate]="isSomeChildSelected(element.childDataSource)"
                            >
                            </mat-checkbox>
                          </ng-container>
                          <ng-template #innerRegularHeader>
                            {{ innerColumn.label }}
                          </ng-template>

                          <span
                            *ngIf="
                              innerColumn.key == 'SubLineofBusiness' ||
                              (innerColumn.labelKey == 'SubLineofBusiness' && innerColumn.filter)
                            "
                          >
                            <span
                              *ngIf="!SubLobFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="SubLobFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span *ngIf="innerColumn.key == 'Year' && innerColumn.filter">
                            <span
                              *ngIf="!subYearFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="subYearFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span *ngIf="innerColumn.key == 'ChiefArchitect' && innerColumn.filter">
                            <span
                              *ngIf="!ChiefArchitectFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="ChiefArchitectFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span *ngIf="innerColumn.key == 'ArchitectDelegate' && innerColumn.filter">
                            <span
                              *ngIf="!ArchitectDelegateFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="ArchitectDelegateFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span *ngIf="innerColumn.key == 'role' && innerColumn.filter">
                            <span
                              *ngIf="!RoleFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="RoleFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span *ngIf="innerColumn.key == 'Users' && innerColumn.filter">
                            <span
                              *ngIf="!NameFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                            </span>
                            <span
                              *ngIf="NameFilterApplied[element['id']]"
                              (click)="filterSubDropdown(element, innerColumn, i)"
                              [matMenuTriggerFor]="subFilters"
                            >
                              <img
                                class="stkh-table-filter-img"
                                src="../../../../assets/images/table_filter_applied.png"
                              />
                            </span>
                          </span>
                          <span
                            *ngIf="
                              innerColumn.key == 'Actions' &&
                              (SubLobFilterApplied[element['id']] ||
                                ChiefArchitectFilterApplied[element['id']] ||
                                ArchitectDelegateFilterApplied[element['id']] ||
                                RoleFilterApplied[element['id']] ||
                                NameFilterApplied[element['id']] ||
                                subYearFilterApplied[element['id']])
                            "
                            (click)="clearallSubFilter(element)"
                          >
                            <i
                              title="Reset Filters"
                              class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                            ></i>
                          </span>
                          <span
                            class="ps-2"
                            *ngIf="innerColumn.key == 'Rate_marginless' && subYearFilterApplied[element['id']]"
                            (click)="clearallSubFilter(element, 'service_year_list')"
                          >
                            <i
                              title="Reset Filters"
                              class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                            ></i>
                          </span>
                        </span>
                      </th>
                    </ng-container>
                    <td
                      mat-cell
                      [style.width]="innerColumn.width"
                      [style.padding]="innerColumn.padding"
                      *matCellDef="let element"
                    >
                      <div [ngSwitch]="innerColumn.key">
                        <span *ngSwitchCase="'select'">
                          <mat-checkbox
                            *ngIf="!element.hideCheckbox"
                            (click)="$event.stopPropagation()"
                            (change)="cheskboxChanged($event, element)"
                            [checked]="selection.isSelected(element)"
                          >
                          </mat-checkbox>
                        </span>
                        <span *ngSwitchCase="'ChiefArchitect'">
                          <div class="scroll-elements">
                            <table>
                              <tbody>
                                <tr *ngFor="let option of element[innerColumn.key]">
                                  <ng-container *ngIf="option.leadEA !== null">
                                    <ng-container *ngIf="option.leadEA == 'Yes'">
                                      <td style="color: #5E2D84; font-weight: 700;">
                                        <span style="color: #5DA430">＊</span>
                                        <span [innerHTML]="sanitize(option.displayName)"></span>
                                      </td>
                                    </ng-container>
                                    <ng-container *ngIf="option.leadEA == 'No'">
                                      <td>
                                        <span class="custom-space"></span>
                                        <span [innerHTML]="sanitize(option.displayName)"></span>
                                      </td>
                                    </ng-container>
                                  </ng-container>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </span>
                        <span *ngSwitchCase="'ArchitectDelegate'">
                          <div class="scroll-elements">
                            <table>
                              <tbody>
                                <tr *ngFor="let option of element[innerColumn.key]">
                                  <ng-container *ngIf="option.leadEA !== null">
                                    <ng-container *ngIf="option.leadEA == 'Yes'">
                                      <td style="color: #5E2D84; font-weight: 700;">
                                        <span style="color: #5DA430">＊</span>
                                        <span [innerHTML]="sanitize(option.displayName)"></span>
                                      </td>
                                    </ng-container>
                                    <ng-container *ngIf="option.leadEA == 'No'">
                                      <td>
                                        <span class="custom-space"></span>
                                        <span [innerHTML]="sanitize(option.displayName)"></span>
                                      </td>
                                    </ng-container>
                                  </ng-container>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </span>
                        <span *ngSwitchCase="'Users'">
                          <div class="scroll-elements">
                            <table>
                              <tbody>
                                <tr *ngFor="let option of element[innerColumn.key]">
                                  <td>
                                    {{ option }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </span>
                        <span *ngSwitchCase="'Actions'">
                          <div
                            [ngClass]="{ 'action-buttons-expand-pencil': selectedOption === 'decom_lob' }"
                            class="action-buttons-expand inner-action-buttons"
                          >
                            <ng-container *ngIf="selectedOption === 'decom_lob' && TABLE_CONFIG.DecomLobEditAccess">
                              <td>
                                <button mat-icon-button (click)="showAddEditPopup('child', element)">
                                  <mat-icon class="icon-crud editPencil">edit</mat-icon>
                                </button>
                              </td>
                            </ng-container>
                            <div>
                              <button
                                mat-icon-button
                                *ngIf="TABLE_CONFIG.edit || TABLE_CONFIG.innerTableEdit"
                                (click)="!isRoleInitiative ? loadEditSubLob(element) : editRole(element)"
                                [title]="isRoleInitiative && (!element?.role) ? 'Use Add/Remove User to add the first user.' : 'Click to Edit Sub LOB' "
                              [class.disabled-button]="isRoleInitiative && (!element?.role)">
                                <mat-icon
                                  class="actionItems excelandinfo-Icon-font editPencil-icon"
                                >
                                  create
                                </mat-icon>
                              </button>
                            </div>
                            &nbsp;
                            <div *ngIf="TABLE_CONFIG.edit">
                              <mat-icon
                                class="mat-icon notranslate material-icons"
                                style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                                (click)="openDeletePopup(element)"
                                aria-hidden="true"
                                data-mat-icon-type="font"
                              >
                                delete
                              </mat-icon>
                            </div>
                          </div>
                        </span>
                        <span *ngSwitchDefault>
                          <ng-container *ngIf="innerColumn.link; else defaultCon">
                            <a [href]="getNavigationLink(innerColumn, element)" target="blank">
                              {{ element[innerColumn.key] }}
                            </a>
                          </ng-container>
                          <ng-template #defaultCon>
                            {{ element[innerColumn.key] }}
                          </ng-template>
                        </span>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="element.displayedChildColumns || displayedChildColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: element.displayedChildColumns || displayedChildColumns" class="example-element-row"></tr>
                </table>

                <mat-paginator *ngIf="!TABLE_CONFIG.serverSidePagination"
                  #childpagination
                  [pageSize]="5"
                  [length]="element.childDataSource.data.length"
                  [pageSizeOptions]="[5, 10, 15]"
                  showFirstLastButtons
                >
                </mat-paginator>

                <!-- Sub-table filter menu - unique per parent row -->
                <mat-menu #subFilters="matMenu">
                  <div
                    class="menu-filter-popup"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  >
                    <input
                      matInput
                      type="text"
                      class="searchoption"
                      (keydown)="$event.stopPropagation()"
                      class="form-control filter-search-bar"
                      [(ngModel)]="searchSubTxt"
                      placeholder="Search"
                    />
                    <mat-selection-list
                      class="filter-list-container"
                      (selectionChange)="selectionSubChange($event, currentFilterColumn, element)"
                      [disableRipple]="true"
                      [(ngModel)]="filSubValue"
                    >
                      <mat-list-option
                        checkboxPosition="before"
                        *ngFor="let row of filterLists | search: searchSubTxt"
                        [value]="row"
                      >
                        <ng-container *ngIf="currentFilterColumn?.type === 'date'; else plainRow">
                          {{ row | date: (currentFilterColumn.dateFormat || 'medium') : (currentFilterColumn.timeZone || undefined) }}
                          <ng-container *ngIf="currentFilterColumn.timeZoneLabel"> {{ currentFilterColumn.timeZoneLabel }}</ng-container>
                        </ng-container>
                        <ng-template #plainRow>{{ row }}</ng-template>
                      </mat-list-option>
                    </mat-selection-list>
                    <span
                      style="cursor:pointer; float: right; padding-right: 70px;"
                      class="small localApplyButton"
                      (click)="applySubLocalFilter(currentFilterColumn, element)"
                      >Apply</span>
                    <span
                      style="cursor:pointer; float: right; padding-right: 22px;"
                      class="small localApplyButton"
                      (click)="clearSubLocalFilter(currentFilterColumn, element)"
                      >Clear</span>
                  </div>
                </mat-menu>
              </div>
            </div>
          </td>
        </ng-container>
      </div>

      <tr mat-header-row class="" *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngStyle]="{ height: noRowHeight ? 'none' : '60px' }"
      ></tr>

      <ng-container>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedRowDetail']"
          class="example-detail-row"
          [ngClass]="{ 'd-none': !isRowExpanded(row) }"
        ></tr>
      </ng-container>
      <ng-container matColumnDef="expandedRowDetail">
        <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumnsKeys.length">
          <div class="sub-row-container" *ngIf="isRowExpanded(row)">
            <div class="sub-row-section">
              <strong>Fields with No Change </strong>
              <span class="sub-row-answer">{{ getUnchangedFields(row) }}</span>
            </div>
            <hr />
            <div *ngIf="getChangedFields(row).length > 0" class="sub-row-section">
              <strong>Changed Fields </strong>
              <table mat-table [dataSource]="getChangedFields(row)" class="inner-table">
                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef style="width: 20%;"></th>
                  <td mat-cell *matCellDef="let element" style="padding-right: 1rem;">
                    <div class="status-wrapper">
                      <span
                        class="status-circle"
                        [ngClass]="{
                          'green-circle': element.Error === '' || element.Error === 'No Error',
                          'red-circle': element.Error !== '' && element.Error !== 'No Error'
                        }"
                      ></span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="key">
                  <th mat-header-cell *matHeaderCellDef style="width: 20%;padding-left: 2rem;">Field Name</th>
                  <td mat-cell *matCellDef="let element" style="padding-left: 2rem;">{{ element.FieldName }}</td>
                </ng-container>
                <ng-container matColumnDef="New">
                  <th mat-header-cell *matHeaderCellDef>New</th>
                  <td mat-cell *matCellDef="let element">{{ element.New }}</td>
                </ng-container>
                <ng-container matColumnDef="Old">
                  <th mat-header-cell *matHeaderCellDef>Old</th>
                  <td mat-cell *matCellDef="let element">{{ element.Old }}</td>
                </ng-container>
                <ng-container *ngIf="isInvalidTable" matColumnDef="Error">
                  <th mat-header-cell *matHeaderCellDef style="width: 20%;">Error</th>
                  <td mat-cell *matCellDef="let element" class="error-message">{{ element.Error }}</td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="
                    isInvalidTable ? ['Status', 'key', 'New', 'Old', 'Error'] : ['Status', 'key', 'New', 'Old']
                  "
                ></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let element;
                    columns: isInvalidTable ? ['Status', 'key', 'New', 'Old', 'Error'] : ['Status', 'key', 'New', 'Old']
                  "
                ></tr>
              </table>
            </div>
            <div *ngIf="getChangedFields(row).length === 0" class="sub-row-section">
              <strong>Changed Fields</strong>
              <span class="sub-row-answer">No fields have changed.</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="nodata">
        <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length" style="text-align: center;">
          <div class="no-records-found">
            <div class="img-align">
              <img class="image-align" src="/assets/images/warning-icon.svg" />
            </div>
            <div class=" data-title">
              <div class="errorTitle">No Data Available</div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-footer-row [hidden]="dataSource && dataSource.data.length > 0" *matFooterRowDef="['nodata']"></tr>

      <ng-container *ngIf="TABLE_CONFIG.expandable">
        <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </ng-container>
    </table>

    <div [hidden]="!(dataSource && dataSource.data.length > 0) || (TABLE_CONFIG.serverSidePagination)">
      <ng-container>
        <mat-paginator
          [pageSize]="TABLE_CONFIG.pageSize"
          class="pagealign"
          [pageSizeOptions]="pageSizeOptions"
          showFirstLastButtons
        ></mat-paginator>
      </ng-container>
    </div>
  </div>
  <app-modal [maximizable]="true" [inViewport]="true" #assignLobLeaderPopUp class="modal-demo">
    <ng-container class="app-modal-header">Assign LOB Leader or Decom Target</ng-container>
    <ng-container class="app-modal-body">
      <app-assign-leader-pop-up
        [lobDetails]="selectedLob"
        (closePopUp)="closeAssignLobLeader()"
        [reloadData]="reloadOnReopen"
      >
      </app-assign-leader-pop-up>
    </ng-container>
  </app-modal>
  <div *ngIf="TABLE_CONFIG.DecomLobEditAccess">
    <app-modal [maximizable]="true" [inViewport]="true" #assignDecomLobPopUp class="modal-demo">
      <ng-container class="app-modal-header">Assign Decom LOB</ng-container>
      <ng-container class="app-modal-body">
        <app-sub-lob-decom-assignment
          [subLobDetails]="selectedSubLob"
          (closePopUp)="closeAssignSubLobDecom()"
          [reloadData]="reloadOnReopen"
        >
        </app-sub-lob-decom-assignment>
      </ng-container>
    </app-modal>
  </div>
  <div class="edit-role-popup">
    <app-modal class="modal-delete" #editRoleModel [maximizable]="true" [inViewport]="true" (closeModal)="hidepopup()">
      <ng-container class="app-modal-header">Edit Role</ng-container>
      <ng-container class="app-modal-body">
        <app-edit-role-popup
          (editSuccessEvent)="saveEditEvent($event)"
          [selectedInitiative]="selectedInitiative"
          [elementData]="editRoleData"
          [dataSource]="dataSource"
        >
        </app-edit-role-popup>
      </ng-container>
    </app-modal>
  </div>
  <div class="rule-dtl-popup">
    <app-modal class="modal-demo" #ruleDtlModel [maximizable]="true" [inViewport]="true" (closeModal)="hidepopup()">
      <ng-container class="app-modal-header">Validation Query</ng-container>
      <ng-container class="app-modal-body">
        {{ validationQuery }}
      </ng-container>
    </app-modal>
  </div>
</div>

<div class="stk-table-loader bulk-loader" *ngIf="showLoader">
  <app-loader> </app-loader>
</div>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalAddLob
  class="modal-demo  lob-add-edit-popups"
  (closeModal)="hidepopup()"
>
  <ng-container class="app-modal-header">Add/Edit Segment</ng-container>
  <ng-container class="app-modal-body">
    <!-- <ng-container *ngIf="isAddEditPopupOpen"> -->
    <!-- NO EXPAND EDIT (Parent) -->
    <ng-container *ngIf="addEditDecomLOBpopupType === 'parent'; else childView">
      <decomLob-add-edit-popup
        [dataSource]="dataSourceDecomLOBSegments"
        [decomSelectedEditRow]="decomSelectedEditRow"
        [type]="addEditDecomLOBpopupType"
        (respondToApplyEmitter)="respondToDecomApply($event)"
      ></decomLob-add-edit-popup>
    </ng-container>

    <!-- EXPAND EDIT (Child)-->
    <ng-template #childView>
      <decomLob-add-edit-popup
        [dataSource]="dataSourceDecomLOBSegments"
        [decomSelectedEditRow]="decomSelectedEditRow"
        [type]="addEditDecomLOBpopupType"
        (respondToApplyEmitter)="respondToDecomApply($event)"
      ></decomLob-add-edit-popup>
    </ng-template>
    <!-- </ng-container> -->
  </ng-container>
</app-modal>
